import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './styles.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Snowflakes from './components/Snowflakes';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import FreeTrial from './pages/FreeTrial';
import Comparisons from './pages/Comparisons';
import Integrations from './pages/Integrations';
import Contact from './pages/Contact';
import About from './pages/About';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import AiSourcingPlatform from './pages/AiSourcingPlatform';
import CompetitorAlternative from './pages/CompetitorAlternative';
import PCRecruiterSourcing from './pages/PCRecruiterSourcing';
import MedicalStaffing from './pages/MedicalStaffing';
import BlogPCRecruiterTools from './pages/BlogPCRecruiterTools';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div className="page-wrapper">
      <Snowflakes />
      <Navbar />
      <main className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/free-trial" element={<FreeTrial />} />
          <Route path="/comparisons" element={<Comparisons />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/ai-sourcing-platform" element={<AiSourcingPlatform />} />
          <Route path="/zoominfo-alternative" element={<CompetitorAlternative competitor="zoominfo" />} />
          <Route path="/apollo-alternative" element={<CompetitorAlternative competitor="apollo" />} />
          <Route path="/lusha-alternative" element={<CompetitorAlternative competitor="lusha" />} />
          <Route path="/seamless-alternative" element={<CompetitorAlternative competitor="seamless" />} />
          <Route path="/pcrecruiter-sourcing" element={<PCRecruiterSourcing />} />
          <Route path="/medical-staffing" element={<MedicalStaffing />} />
          <Route path="/blog/best-sourcing-tools-pcrecruiter" element={<BlogPCRecruiterTools />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
